var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62669 8.7446C6.93088 9.15128 7.31898 9.48778 7.76466 9.73127C8.21034 9.97476 8.70317 10.1196 9.20973 10.1558C9.71629 10.1921 10.2247 10.119 10.7006 9.94153C11.1764 9.76403 11.6085 9.48628 11.9675 9.1271L14.0925 7.0021C14.7377 6.33414 15.0946 5.43951 15.0866 4.51089C15.0785 3.58228 14.706 2.69398 14.0494 2.03733C13.3927 1.38068 12.5044 1.0082 11.5758 1.00013C10.6472 0.992064 9.75257 1.34904 9.0846 1.99419L7.86627 3.20544M9.46002 7.32794C9.15583 6.92126 8.76773 6.58477 8.32205 6.34127C7.87637 6.09778 7.38354 5.95298 6.87698 5.9167C6.37042 5.88042 5.86198 5.95351 5.38615 6.13101C4.91032 6.30851 4.47823 6.58626 4.11919 6.94544L1.99419 9.07044C1.34904 9.7384 0.992064 10.633 1.00013 11.5617C1.0082 12.4903 1.38068 13.3786 2.03733 14.0352C2.69398 14.6919 3.58228 15.0643 4.51089 15.0724C5.43951 15.0805 6.33414 14.7235 7.0021 14.0784L8.21335 12.8671",
    stroke: "#FCFDFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link_2.95f6ce17a40c36600c8623c9082040ef.svg";
export { ForwardRef as ReactComponent };